export default __webpack_public_path__ + "static/media/whatsapp.dc7ca151.svg";